<template>
  <ListItem :order="order" class="external-list-item">
    <p class="external-list-item__info">Номер полісу: <strong>{{ order.id }}</strong></p>
  </ListItem>
</template>

<script>
import ListItem from '../list-item';

export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  components: { ListItem },
};
</script>

<style lang="scss" scoped>
.external-list-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media (max-width: 550px) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 16px;
  }

  &__info {
    font-family: inherit;
    font-size: 14px;
    font-weight: 400;
    color: #71717A;
    margin-right: 5px;

    strong {
      font-weight: 700;
    }
  }
}
</style>
